<template>
  <b-modal
    id="modalConfigGateway"
    centered
    title="Insert Specific Gateway"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="gateway" class="form-label">Gateway</label>
      <b-form-input
        id="gateway"
        v-model="gateway"
        placeholder="Digite o nome do gateway (ex: IUGU)"
        type="text"
        :state="!errorsForm.gateway"
      />
      <b-form-invalid-feedback v-if="errorsForm.gateway">
        {{ errorsForm.gateway }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="user_id" class="form-label">ID do Usuário</label>
      <b-form-input
        id="user_id"
        v-model="user_id"
        placeholder="Digite o ID do usuário"
        type="number"
        :state="!errorsForm.user_id"
      />
      <b-form-invalid-feedback v-if="errorsForm.user_id">
        {{ errorsForm.user_id }}
      </b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Concluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import operationsService from '@services/resources/OperationsService';

const setGateway = operationsService.build();

export default {
  name: 'modalConfigGateway',
  data() {
    return {
      gateway: '',
      user_id: '',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.gateway.trim()) {
        this.errorsForm.gateway = 'O campo Gateway é obrigatório.';
      }

      if (!this.user_id.toString().trim()) {
        this.errorsForm.user_id = 'O campo ID do Usuário é obrigatório.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },
    async submitData() {
      if (!this.validateFields()) return;

      try {
        const payload = {
          gateway: this.gateway,
          user_id: this.user_id,
        };

        await setGateway.post('set-gateway', payload);

        this.$bvToast.toast('Gateway configurado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalConfigGateway');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao configurar gateway';

        if (
          error.response &&
          error.response.status === 422 &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);

          if (parsed.errors) {
            message = Object.values(parsed.errors)
              .flat()
              .join('\n');
          }

        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.message
        ) {
          message = error.response.data.message;

        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },
    resetForm() {
      this.gateway = '';
      this.user_id = '';
      this.errorsForm = {};
    },
  },
};
</script>
